module.exports = __webpack_public_path__ + "img/logo.6ddcf3b8.png";